import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  orgDataService
} from 'app/services';
import {
  alerts,
  datePicker,
} from 'app/components/global';
import controller from './begin-service-trial-dialog.controller';
import template from './begin-service-trial-dialog.html';

// TODO: add start-trial.end-date.messages.html to $templateCache

export class dialogService {
  getOptions($event, {
    serviceId = -1,
    customerId = -1
  }) {
    return {
      controller,
      controllerAs: 'beginServiceTrialDialogVM',
      locals: {
        serviceId,
        customerId
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.customerAdministration.beginServiceDialog', [
  copy,
  alerts,
  ssDialogService,
  orgDataService,
  loaderService,
  datePicker
])
  .service('beginServiceTrialDialog', dialogService)
  .name;

console.log('app.components.admin.customerAdministration.beginServiceDialog created');
